<template>
  <a-form-item :label="data.fieldname">
    <div
      v-decorator="[`${data.fieldkey}`, {
        rules: [{ required: data.isneeded === 1 ? true : false, message: placeholder }],
        initialValue: defaultValue
      }]"
    >
      <a-checkbox-group
        :value="defaultValue"
        @change="onChange"
      >
        <a-checkbox
          v-for="item in options"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </a-checkbox>
      </a-checkbox-group>
    </div>
  </a-form-item>
</template>

<script>
export default {
  inject: {
    myForm: {
      type: Object,
      default: null
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      defaultValue: []
    }
  },
  computed: {
    options () {
      let { fieldtype, options = [], fieldconfig = {} } = this.data
      const { type } = fieldconfig
      if (fieldtype === 'radioinfo_level') {
        options = this.LevelOption(options, type)
      }
      return options
    }
  },

  created () {
    let { fieldvalue = [] } = this.data || {}
    this.defaultValue = fieldvalue
  },
  methods: {
    onChange (val) {
      const { fieldkey } = this.data
      this.data.fieldvalue = val
      this.defaultValue = val
      this.$emit('change', val)
      this.myForm && this.myForm.setFieldsValue({
        [fieldkey]: val
      })
    },
    LevelOption (options, type) {
      let arr = []
      if (type === 1) {
        arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      } else if (type === 2) {
        arr = this.$t('message["1444"]').split(',')
      }
      options.forEach((item, index) => {
        arr.forEach((code, i) => {
          if (index === i) {
            item.name = code
          }
        })
      })
      return options
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-form-item label {
  word-break: break-all;
}
</style>
